/**
 * Reusable From and Content Components
 */

// eslint-disable-next-line simple-import-sort/imports
import { App } from '~/app';

import initialisePasswordFormField from './fields/password/password';
import initialiseSelectFormField from './fields/select/select';
import initialiseButtonGroupingFormField from './fields/button-grouping/button-grouping';
import initialiseMultiButtonGroupingFormField from './fields/multi-button-grouping/multi-button-grouping';
import initialiseLocationBox from './fields/location-box/location-box'
import initialiseFreeTextQuickLinks from './quick-links/quick-links';
import initialiseForm from './forms/form';
import initialiseModal from './modal/modal';
import initialiseShareOnSocials from './share-on-socials/share-on-socials';
import initialiseImageWithCaption from './rich-text/image-with-caption/lazy-image-with-caption';
import initialiseVideo from './video/video';
import initialiseModalForm from './modal-form/modal-form';
import { defineAsyncComponent } from 'vue';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Reusable From and Content Components');
    app.vueApp.component('inline-error', defineAsyncComponent(async () => import("./inline-error/InlineError.vue")));
    app.vueApp.component('stockland-select', defineAsyncComponent(async () => import("./fields/select/StocklandSelect.vue")));
    app.vueApp.component('stockland-button', defineAsyncComponent(async () => import("./button/StocklandButton.vue")));
    app.vueApp.component('stockland-radio-button', defineAsyncComponent(async () => import("./fields/radio-button/StocklandRadioButton.vue")));
    app.vueApp.component('stockland-multi-select', defineAsyncComponent(async () => import("./fields/multi-select/StocklandMultiSelect.vue")));
    app.vueApp.component('stockland-multi-select-with-checkboxes', defineAsyncComponent(async () => import("./fields/multi-select-with-checkboxes/StocklandMultiSelectWithCheckboxes.vue")));
    app.vueApp.component('stockland-icon', defineAsyncComponent(async () => import("./icon/StocklandIcon.vue")));
    app.vueApp.component('counter', defineAsyncComponent(async () => import("./fields/counter/Counter.vue")));
    app.vueApp.component('resized-image', defineAsyncComponent(async () => import("./resized-image/ResizedImage.vue")));
    app.vueApp.component(
        'tab-selection',
        defineAsyncComponent(async () => import('./group-fields/tab-filter/TabSelection.vue'))
    );
    app.vueApp.component(
        'vue-buttons-group',
        defineAsyncComponent(async () => import('./group-fields/vue-buttons-group/VueButtonsGroup.vue'))
    );
    app.vueApp.component(
        'multi-range-slider',
        defineAsyncComponent(async () => import('./fields/range-slider/MultiRangeSlider.vue'))
    );

    app.vueApp.component(
        'location-box',
        defineAsyncComponent(async () => import('./fields/location-box/LocationBox.vue'))
    );

    const destroyButtonGroupingFormField = initialiseButtonGroupingFormField(app);
    const destroyMultiButtonGroupingFormField = initialiseMultiButtonGroupingFormField(app);
    const destroyForm = initialiseForm(app);
    const destroyFreeTextQuickLinks = initialiseFreeTextQuickLinks(app);
    const destroyImageWithCaption = initialiseImageWithCaption(app);
    const destroyModal = initialiseModal(app);
    const destroyPasswordFormField = initialisePasswordFormField(app);
    const destroySelectFormField = initialiseSelectFormField(app);
    const destoryShareOnSocials = initialiseShareOnSocials(app);
    const destroyVideo = initialiseVideo(app);
    const destroyModalForm = initialiseModalForm(app);
    const destroyLocationBox = initialiseLocationBox(app);

    return function destroyComponents() {
        // Component de-registration
        destroyForm();
        destroyFreeTextQuickLinks();
        destroyImageWithCaption();
        destroyModal();
        destroyPasswordFormField();
        destroySelectFormField();
        destoryShareOnSocials();
        destroyVideo();
        destroyModalForm();
        destroyButtonGroupingFormField();
        destroyMultiButtonGroupingFormField();  
        destroyLocationBox();

        app.logger.debug('[Stockland FE] Form and Content Components destroyed');
    };
};
